import axiosInstance from '../services/AxiosInstance';

export function getPropertyTypes(pageNum = 1, pageSize = 10, searchTerm = "", filterQuery = "") {
    return axiosInstance.get(`property-type?pageNum=${pageNum}&pageSize=${pageSize}&search=${searchTerm}`);
}

export function getAllPropertyTypes() {
    return axiosInstance.get(`property-type/all`);
}

export function deletePropertyType(propertyTypeId) {
    return axiosInstance.delete(`property-type/${propertyTypeId}`);
}

export function createPropertyType(propertyTypeData) {
    return axiosInstance.post(`property-type`,propertyTypeData);
}

export function updatePropertyType(propertyTypeId, propertyTypeData) {
    return axiosInstance.put(`property-type/${propertyTypeId}`,propertyTypeData);
}
